import React from 'react'
import { ValidationRule } from 'react-hook-form'
import { twMerge } from 'tailwind-merge'

export const InputLabel = (props: {
  label: string
  required?: boolean | string | ValidationRule
  noLabel?: boolean
  className?: string
}) => {
  return (
    <label
      className={twMerge(
        'text-xs sm:text-sm block font-medium mb-2 leading-5 dark:bg-transparent dark:pl-2 dark:text-base-300 text-base-700',
        props.noLabel && 'sr-only',
        props.className,
      )}
      htmlFor={props.label}>
      <span
        className={twMerge(
          'text-xs sm:text-sm dark:text-white',
          'dark:text-white text-base-500',
        )}>
        {props.label}
        {props.required && <span className='pl-1 text-red-400'>*</span>}
      </span>
    </label>
  )
}
